import { html } from 'lit-html';
import { ItemRequestJsEnv } from '../models/item_request_js_env';
import { getAssetsUrlBase } from '../../../core/models/common/static_resource_util';

export const SendSuccess = (model: ItemRequestJsEnv) => {
  const firstViewSection: HTMLElement = <HTMLElement>document.getElementById('firstView');
  if (model.isSendSuccess) {
    firstViewSection.style.display = 'none';
    return html`
          <div class="o-contentWidth -width943">
            <div class="o-simplemodal_container">
              <div class="o-simplemodal_inner">
                <div role="dialog" aria-modal="true" aria-describedby="modal-SLPSRC021_02-content" class="o-simplemodal_body">
                  <div class="o-simplemodal_main" id="modal-SLPSRC021_02-content" aria-labelledby="modal-SLPSRC021_02-content">
                    <div class="a-heading -typeh5 u-mb-32 u-text-center">
                      <h2 class="a-heading_text">リクエストありがとうございました</h2>
                    </div>
                    <div class="o-wrapper u-mb-32 u-text-center js-reporterror">
                      <div class="a-img -static"><span class="a-img_imgWrap"><img src="${getAssetsUrlBase()}animes/img_reporterror.gif" class="a-img_img" alt="" width="100" /></span></div>
                    </div><button class="m-btn -center -base -middle" type="button" data-micromodal-close="true"><span class="m-btn_inner"><span class="m-btn_text">閉じる</span></span></button>
                  </div>
                </div>
              </div>
            </div>
          </div>`;
  } else {
    firstViewSection.style.display = 'block';
    return html``;
  }
}

